import request, { IServerResponse } from '@/utils/request';

import { IGetTokenRes } from './define';

export const getToken = (): Promise<IServerResponse<IGetTokenRes>> =>
    request.get('/epassport/user');
